import * as React from "react"
import {
  Flex,
  Accordion,
  Box,
  AccordionItem,
  AccordionIcon,
  AccordionPanel,
  Divider
} from "@chakra-ui/react"
import { DropdownButton } from "../../mediaPanel/buttonsLocalView/start-screen-buttons/start-screen-buttons.styled"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { waitForElm } from "../../../util/waitForElm"
import { PrivateRoomProps, PrivateRoomOptions } from "./types"
import { privateRoomTabTypeAtom } from "../../../recoil/atoms/privateRoom"
import { useTranslation } from "react-i18next"
import { Tooltip } from "../../common/tooltip"

const PrivateRoom: React.FC<PrivateRoomProps> = ({ expandId, userId }) => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const setPrivateRoomTabType = useSetRecoilState(privateRoomTabTypeAtom)

  const options: PrivateRoomOptions[] = [
    { id: 1, text: t("Open in new tab"), type: "NEW_TAB" },
    { id: 2, text: t("Open in this tab"), type: "CURRENT_TAB" }
  ]

  const openPrivateRoom = (item: PrivateRoomOptions) => {
    setPrivateRoomTabType(item.type)
    window.MeetOnline?.client().startPrivateRoom(userId)
  }

  const toggleAccordion = async () => {
    const element = (await waitForElm(expandId)) as HTMLDivElement

    element.style.maxHeight = element.scrollHeight + 200 + "px"
  }

  return (
    <Flex padding="0rem 0.5rem 0.5rem 0.5rem" width="100%">
      <Accordion allowToggle marginBottom="0.4rem" pos="relative" width="100%">
        <AccordionItem border="none">
          <DropdownButton
            roomStyles={roomStyles}
            _focus={{}}
            onClick={toggleAccordion}
            style={{ zIndex: 1000 }}
          >
            <Box flex="1">
              <Box paddingLeft="20px">{t("Go to private room")}</Box>
            </Box>
            <AccordionIcon />
          </DropdownButton>
          <AccordionPanel
            borderStyle={"none"}
            padding="10px 0 10px 0"
            disabled={true}
          >
            <Flex
              width={"100%"}
              flexDirection={"column"}
              maxH={"100px"}
              overflowY={"auto"}
              border={`1px solid ${roomStyles?.secondaryAccessButtonBorderColor}`}
              borderRadius="0.375rem"
            >
              {options.map((item, index) => (
                <React.Fragment key={`private-room-type-list-${index}`}>
                  <Flex
                    width="100%"
                    key={item.id}
                    color={roomStyles.secondaryAccessButtonTextColor || "#fff"}
                    bg={
                      roomStyles.secondaryAccessButtonBackgroundColor || "#fff"
                    }
                    _hover={{
                      bg:
                        roomStyles.secondaryAccessButtonMouseoverColor ||
                        "#fff",
                      color:
                        roomStyles.secondaryAccessButtonTextMouseoverColor ||
                        "#fff"
                    }}
                  >
                    <Tooltip label={item.text}>
                      <Flex
                        paddingLeft={"10px"}
                        display="block"
                        margin="0.35rem"
                        alignItems={"center"}
                        width="100%"
                        fontSize="0.95rem"
                        fontWeight="500"
                        textOverflow="ellipsis"
                        whiteSpace={"nowrap"}
                        overflow="hidden"
                        cursor="pointer"
                        textAlign="center"
                        onClick={() => openPrivateRoom(item)}
                      >
                        {item.text}
                      </Flex>
                    </Tooltip>
                  </Flex>
                  {index === 0 && (
                    <Divider
                      /* marginTop="0.3rem" */
                      borderColor={roomStyles?.secondaryAccessButtonBorderColor}
                    />
                  )}
                </React.Fragment>
              ))}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}

export default PrivateRoom
